module.exports = __webpack_public_path__ + "a3fa97ad5623461afae94208b1fe0dcf.jpg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../loaders/scale-loader?size=410!./images/broschuere_image.jpg
// module id = 468
// module chunks = 0